import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import * as Util from '../../../util';
import ReviewType from '../ReviewType';
import { connectToUser } from '../../User/containers/UserDataStore';

const ReviewsContext = React.createContext();

const name = 'reviewsDataStore';

export const useReviews = () => React.useContext(ReviewsContext);

export const connectToReviews = makeConnectTo(ReviewsContext, name);
class ReviewsDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		reviews: [],
		selectedMenuOption: ReviewType.All.key,
		isLoading: true,
	};

	render() {
		const reviewsDataStore = this.getStore();
		return (
			<ReviewsContext.Provider value={reviewsDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(reviewsDataStore)
					: this.props.children}
			</ReviewsContext.Provider>
		);
	}

	componentDidMount() {
		const { isAnonymous } = this.props.userDataStore;
		if (!isAnonymous()) {
			this.fetchReviews();
		} else {
			this.setState({ isLoading: false });
		}
	}

	componentWillUnmount() {
		if (this.reviewsFetch && this.reviewsFetch.cancel) {
			this.reviewsFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshReviews(),
		setSelectedMenuOption: selectedMenuOption =>
			this.setSelectedMenuOption(selectedMenuOption),
	});

	refreshReviews = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchReviews();
		return this.reviewsFetch.promise;
	};

	fetchReviews = () => {
		const request = api.cancelableGet(`/api/v1/me/reviews`);
		request.promise.then(this.cacheApiResponse);
		this.reviewsFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const reviews = apiResponse && Util.createTitleObject(apiResponse);
		this.setState({ reviews, isLoading: false });
	};

	setSelectedMenuOption = selectedMenuOption => {
		this.setState({ selectedMenuOption });
	};
}

export default connectToUser(ReviewsDataStore);
